module.exports = __webpack_public_path__ + "media/images/vimeo_web@2x-e1e5f029647637267952f291566db467.png";